import { Appendix } from "../../../../shared/entities/scripts/appendix";
export class BiospecimenInventoryLookup {
    static SAMPLE_TYPES: string[] = [
        "Plasma - EDTA",
        "Plasma - Na Hep",
        "Serum - SST",
        "Stool - OMR-205",
        "Stool - ME-200",
        "Whole Blood - EDTA",
        "PAXgene RNA",
        "PBMC - CPT Na Citrate",
        "Plasma - CPT Na Hep",
        "PBMC - Na Hep"
    ];
    static GetAlphabeticalSampleTypes(): string[] {
        return [...this.SAMPLE_TYPES].sort((a, b) => a.localeCompare(b));
    }

    static GetValueFromIdAndType(id: number, type: string): string {
        if (type == 'trial') {
            return Appendix.GetAppendixName(id);
        }
        else if (type == 'sample-type') {
            switch (id) {
                case 0: return "Plasma - EDTA";
                case 1: return "Plasma - Na Hep";
                case 2: return "Serum - SST";
                case 3: return "Stool - OMR-205";
                case 4: return "Stool - ME-200";
                case 5: return "Whole Blood - EDTA";
                case 6: return "PAXgene RNA";
                case 7: return "PBMC - CPT Na Citrate";
                case 8: return "Plasma - CPT Na Hep";
                case 9: return "PBMC - Na Hep";
                default: return "Missing Value";
            }
        }
        else if (type == 'recover-cohort') {
            switch (id) {
                case (0): return "Unknown"
                case (1): return "No";
                case (2): return "Yes";
                //case (9): return "Unknown";
            }
        }
        else if (type == 'specimen-status') {
            switch (id) {
                case (1): return "Allocated"; 
                case (2): return "Received";
                default: return "Unknown Status";
            }
        }
        else if (type == 'sex') {
            switch (id) {
                case (0): return "Female";
                case (1): return "Male";
                case (2): return "Intersex";
                case (3): return "Prefer Not To Answer";
                default: return "Unknown";
            }
        }
        else if (type == 'race') {
            switch (id) {
                case (0): return "Multi-Racial";
                case (1): return "American Indian or Alaska Native";
                case (2): return "Asian";
                case (3): return "Black";
                case (4): return "Middle East or North Africa";
                case (5): return "Native Hawaiian or Pacific Islanders";
                case (6): return "White";
                case (7): return "Unknown";
                default: return "Missing Value";
            }
        }
        else if (type == 'ethnicity') {
            switch (id) {
                case (1): return "Not Hispanic";
                case (2): return "Hispanic";
                case (3): return "Unknown";
                default: return "No information";
            }
        }
        else if (type == 'age') {
            switch (id) {
                case (0): return "18 - 45";
                case (1): return "46 - 65";
                case (2): return ">65";
                case (3): return "Unknown";
                default: return "No Information";
            }
        }
    }
}